import * as React from "react";
import { dispatch } from "@rematch/core";
import { connect } from "react-redux";
import { Select } from "antd";

const Option = Select.Option;

interface IMultipleTagsProps {
  width?: number;
  setValue?: any;
  modelName?: any;
  placeholder?: any;
  // 默认值
  defaultValue?: any;
  value?: any;
  // 自定义字段，映射viewModel的字段
  field?: any;
  // 数据源
  data: any;
}

class MultipleTags_Simple extends React.Component<IMultipleTagsProps, any> {
  constructor(props: IMultipleTagsProps) {
    super(props);
  }

  getChild = () => {
    let children: any = [];
    this.props.data.map((item: any, index: any) => {
      children.push(
        <Option key={index} value={item.id}>
          {item.name}
        </Option>
      );
    });
    return children;
  };

  handleChange = value => {
    let data = {};
    data[this.props.field] = value;
    dispatch["antDemo"].setValue({
      formInfo: data,
      model: this.props.modelName,
      field: this.props.field,
      value: value
    });
  };

  render() {
    return (
      <React.Fragment>
        <Select
          mode="multiple"
          style={{ width: "100%" }}
          allowClear={true}
          showArrow={true}
          placeholder={this.props.placeholder || "选择一项"}
          //        defaultValue={["a10", "c12"]}
          value={this.props.value}
          onChange={this.handleChange}
        >
          {this.getChild()}
        </Select>
      </React.Fragment>
    );
  }
}

const mapDispatch = dispatch => {
  return {
    getSupplier: dispatch.selectorSource.getSupplier,
    getProductCate: dispatch.selectorSource.getProductCate,
    getUser: dispatch.selectorSource.getUser
  };
};

export default connect(
  null,
  mapDispatch
)(MultipleTags_Simple);
